<template>
	<div>
		<div v-if="snackbar">
			<SSnackbar :message="message" />
	    </div>

		<div v-if="toast">
			<SToast
	          :time-out="timeOut"
	          :message="message"
	          :type="type"
	        ></SToast>
		</div>
	</div>
</template>

<script>
import SToast from "./SToast.vue";
import SSnackbar from "./SSnackbar.vue";

export default {
	name: "SNotify",

	data(){
		return{
			toast: false,
			snackbar: false
		}
	},

	components: {
	 SToast,
	 SSnackbar
	},

	props: {
		message: {type: String, required: true},
		timeOut: {type: Number, required: false},
		type: {type: String, default: 'success'},
		progress: {type: Boolean, required: true}
	},

	methods: {},

	mounted(){
		if(this.progress){
			this.toast = true;
		}
		else{
			this.snackbar = true;
		}
	}
}
</script>

<style scoped>

</style>